// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2J48P","icon":"styles_icon__2Nudt"};